import { useQuery } from '@tanstack/react-query';

import { accountRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useExtendedBillingAccount = () => {
  const query = useQuery({
    queryKey: [QueryKeys.EXTENDED_BILLING_ACCOUNT],
    queryFn: accountRepo.getExtendedBillingAccount,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};

export type UseExtendedBillingAccount = ReturnType<typeof useExtendedBillingAccount>;
